import React from 'react';
import { EmptyDonut, EmptyPie } from '@fabric-ui/icons/emptyStates';
import { flex, shadowInsetBorder } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import AlertScoreEmptyState from '../Threats/AlertScoreEmptyState';
import { entityViewWidgetStyle } from './utils';

const variantToSvg = {
  donut: <EmptyDonut style={{ width: 162, height: 137 }} />,
  pie: <EmptyPie style={{ width: 162, height: 137 }} />,
};

const AlertScoreWidgetEmptyState = ({ title, variant = 'donut' }: { title?: string; variant?: keyof typeof variantToSvg }) => (
  <Box
    sx={{
      ...flex.col,
      svg: { width: 'auto', height: 'auto' },
      p: '16px 16px 0px 24px',
      overflow: 'hidden',
      ...entityViewWidgetStyle,
      boxShadow: shadowInsetBorder,
      backgroundColor: theme => theme.palette.white.main,
    }}>
    <Box sx={{ mb: 2, fontSize: 14, fontWeight: 600 }}>{title}</Box>
    <Box sx={{ ...flex.center, gap: 3.5 }}>
      {variantToSvg[variant]}
      <Box sx={{ ...flex.colJustifyCenter, whiteSpace: 'pre-line', maxWidth: 260 }}>
        <AlertScoreEmptyState />
      </Box>
    </Box>
  </Box>
);

export default AlertScoreWidgetEmptyState;
